import { DOCUMENT, Injectable, inject } from '@angular/core';
import { BasicStorageService } from './base-storage.service';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService extends BasicStorageService {
  constructor() {
    const doc = inject<Document>(DOCUMENT);

    super(doc.defaultView.localStorage);
  }
}
